import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { PATHS } from '../../../shared/paths';
import { EspanolService } from '../components/disease-es/espanol.service';

@Injectable({
    providedIn: 'root',
})
export class EspanolDiseaseResolver {
    constructor(private espanolService: EspanolService, private router: Router) {}

    resolve(route: ActivatedRouteSnapshot): Observable<string | null> {
        const diseaseId = route.params.diseaseId as string;

        return this.espanolService.getSpanishPage(`Disease_${diseaseId}.dat`).pipe(
            catchError(() => {
                this.router.navigate([PATHS.notFound], { skipLocationChange: true });
                return of(null);
            }),
        );
    }
}
